<template>
    <Page type="white">
        <template v-slot:body>
            <Converter />
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import Page     from '@/components/sides/Page.vue' 
import Converter from '@/components/widgets/Converter.vue' 
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            header: {
                en:{
                    title: "Converter",
                },
                ru:{
                    title: "Конвертер",
                }
            },
            status: null,
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
    },
    components: {
        Page,
        Converter,
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        async getStatus(){
            const status = await this.connect.GetStatus().then(res => res).catch(error => {})
            if (status) this.status = status
            else this.status = 'unknown'
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.getStatus()
        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>